// Translations for marketing landing page (German + English).
// Legal pages (Impressum, AGB, Datenschutz) and Admin remain German on purpose.
export const translations = {
  de: {
    nav: {
      konzept: "Konzept",
      ablauf: "So funktioniert's",
      track: "Track Record",
      konditionen: "Konditionen",
      faq: "FAQ",
      cta: "Anfrage stellen",
    },
    hero: {
      tag: "Alphalane AI · KI-gestütztes Trading 24/5",
      h1a: "Alphalane AI — Profitiere vom Markt ",
      h1b: "ohne selbst zu handeln.",
      sub: "Alphalane AI (Alphalane Trading Systems) managt dein Handelskonto vollautomatisch nach klaren, regelbasierten Kriterien. Dein Geld bleibt zu 100 % in deinem Namen — die KI handelt, du wächst. Betrieben von Moonshine Solutions GmbH in der Schweiz.",
      ctaPrimary: "Jetzt Anfrage stellen",
      ctaSecondary: "So funktioniert's",
      stat1: "Aktiv im Markt",
      stat2: "Performance Fee",
      stat3: "Mindesteinlage",
      liveStatus: "Live Status",
      strategy: "Strategie",
      strategyVal: "Alpha AI V2",
      drawdown: "Max. zwischenzeitlicher Verlust",
      drawdownVal: "5% / Woche",
      cumulSinceTpl: "Kumuliert seit {month}",
      historicalNote: "Historische Performance — keine Garantie für die Zukunft.",
    },
    concept: {
      tag: "Das Konzept",
      h2a: "KI-Technologie trifft auf ",
      h2b: "bewährte Strategien.",
      sub: "Alphalane verbindet moderne Künstliche Intelligenz mit erprobten Trading-Strategien zu einem System, das Märkte analysiert, Entscheidungen trifft und Trades automatisch ausführt — ohne Stress, ohne Emotionen, rund um die Uhr.",
      cards: [
        { title: "KI-Analyse", text: "Erkennung von Trends & Chancen in Echtzeit – datengetrieben und ohne Verzögerung." },
        { title: "Risikomanagement", text: "Gewinne sichern, Verluste begrenzen. Klare Drawdown-Limits und manuelle Aufsicht." },
        { title: "Automatisiert", text: "Analyse, Entscheidung und Ausführung in einem geschlossenen, regelbasierten System." },
        { title: "Emotionsfrei", text: "Konsequent ohne Stress oder Gefühle – egal, ob Angst oder Gier den Markt bewegen." },
      ],
    },
    how: {
      tag: "Los geht's",
      h2a: "In 5 Schritten zum ",
      h2b: "automatisierten Trading.",
      sub: "Klar, transparent und jederzeit nachvollziehbar — vom ersten Setup bis zum Echtzeit-Tracking deiner Performance.",
      steps: [
        { n: "01", title: "Investmentgröße festlegen", text: "Bestimme, wieviel Kapital du investieren möchtest. Wichtig: Setze nur Kapital ein, dessen Verlust im schlimmsten Fall für dich tragbar wäre." },
        { n: "02", title: "Brokerkonto eröffnen", text: "Du eröffnest ein eigenes Handelskonto bei einem unserer Partner-Broker und zahlst den gewünschten Betrag ein. Konto bleibt auf deinen Namen." },
        { n: "03", title: "Konto verbinden", text: "Nach Abschluss aller notwendigen Schritte verbinden wir dein Brokerkonto mit unserem Trading-System." },
        { n: "04", title: "Trading startet", text: "Unser System analysiert die Charts im Futures-Markt, findet optimale Einstiege und führt Trades nach unserem Risikomanagement aus." },
        { n: "05", title: "Alles im Blick", text: "Über dein Brokerkonto und das persönliche Dashboard verfolgst du die Kapitalentwicklung jederzeit in Echtzeit." },
      ],
    },
    track: {
      tag: "Track Record",
      h2a: "Ergebnisse & ",
      h2b: "Kennzahlen.",
      sub: "Historische monatliche Renditen seit Mai 2025. Diese Daten dienen ausschließlich der Information — sie sind kein Versprechen für zukünftige Ergebnisse.",
      kpiBest: "Bester Monat",
      kpiWorst: "Schwächster Monat",
      kpiDrawdown: "Max. zwischenzeitlicher Verlust",
      kpiCumul: "Kumuliert",
      colMonth: "Monat",
      colMonthly: "Rendite (Monat)",
      colCumul: "Kumuliert",
      colTrend: "Verlauf",
      paused: "Pausiert infolge System-Upgrade",
      colExample: "Bei 10'000 Start",
      exampleNote: "Beispielrechnung: Startkapital 10'000 — Endstand basierend auf der historischen Performance. Vergangene Performance ist keine Garantie für zukünftige Ergebnisse.",
      chartTitle: "Performance-Verlauf",
      chartSub: "Kumulierte Rendite seit Start.",
      noteTitle: "Kontinuierliche Selbstoptimierung",
      noteText: "Unsere KI verbessert sich laufend, um Risikomanagement und Infrastruktur weiter zu optimieren — für mehr Stabilität, breitere Diversifikation und kürzere Tradelaufzeiten. Die aktuelle Programmierung ist seit dem 18. März 2026 live. Alle vorherigen Monatswerte basieren auf Backtests dieser aktuellen Version mit einer Genauigkeit von 98 % (Latenzbedingt).",
      goalTitle: "Angestrebte Rendite pro Monat 5 – 20 %",
      goalText: "Unser Fokus liegt darauf, den zwischenzeitlichen Verlust pro Trade extrem tief zu halten. Die Rendite, die sich daraus ergibt, kann niemals garantiert werden — das Team von Alphalane ist bestrebt, eine monatliche Rendite zwischen 5 – 20 % zu erzielen. Für weitere Informationen oder Statistiken steht das Team jederzeit bereit.",
      goalCta: "Statistiken anfragen",
      noteEyebrow: "Optimierungs-Hinweis",
      goalEyebrow: "Zielsetzung",
      showAll: "Alles anzeigen",
      showLess: "Nur die letzten 3 Monate",
    },
    cond: {
      tag: "Konditionen",
      h2a: "Klare Konditionen. ",
      h2b: "Keine Überraschungen.",
      sub: "Performance-basiertes Modell: Alphalane verdient nur, wenn du verdienst. Keine Fixkosten, keine Gebühren in Verlustmonaten.",
      benefitsTitle: "Was du erhältst",
      benefits: [
        "Vollautomatisches Trading auf deinem eigenen Konto",
        "Manuelle Überwachung durch unser Team zusätzlich zur Strategie",
        "Geprüftes & abgesichertes Risikomanagement",
        "Diversifiziertes Trading in mehreren Futures-Märkten",
        "Jederzeit pausierbar oder per Wochenfrist kündbar",
      ],
      items: [
        { label: "Mindesteinlage", value: "ab 2.000 USD" },
        { label: "Performance Fee", value: "40 % auf Gewinne" },
        { label: "Laufzeit", value: "Individuell, keine Bindung" },
        { label: "Auszahlungen", value: "innerhalb Wochenfrist" },
        { label: "Konto-Inhaber", value: "Ausschließlich auf deinen Namen" },
        { label: "Transparenz", value: "Eigenes Dashboard, Echtzeit-Einblick" },
      ],
    },
    forwhom: {
      tag: "Für wen geeignet",
      h2a: "Für alle, die ",
      h2b: "smart investieren",
      h2c: " wollen.",
      personas: [
        { title: "Investoren", text: "Die vom Markt profitieren möchten, ohne selbst handeln zu müssen." },
        { title: "Trader", text: "Die ein zuverlässiges, emotionsfreies System suchen." },
        { title: "Profis", text: "Die Geschwindigkeit, Datenqualität und Struktur schätzen." },
      ],
    },
    faq: {
      tag: "FAQ",
      h2a: "Häufige ",
      h2b: "Fragen.",
      items: [
        { q: "Ist mein Geld sicher?", a: "Ja. Das Handelskonto läuft ausschließlich auf deinen Namen bei einem regulierten Broker. Wir haben keinen Zugriff auf Ein- oder Auszahlungen, sondern nur auf die Handelsausführung." },
        { q: "Gibt es eine Mindestlaufzeit?", a: "Nein, die Laufzeit ist individuell. Du kannst den Service jederzeit pausieren oder per Wochenfrist beenden." },
        { q: "Welche Kosten entstehen für mich?", a: "Es fällt ausschließlich eine Performance Fee von 40 % auf erzielte Gewinne an. Keine Fixkosten, keine Gebühren in Verlustmonaten." },
        { q: "Welche Renditen kann ich erwarten?", a: "Es gibt keine garantierten Renditen. Die tatsächliche Performance hängt von den Marktbedingungen ab. Unsere historischen Ergebnisse zeigen jedoch eine kontinuierliche Entwicklung bei überschaubaren Rückschlägen." },
        { q: "Wann erhalte ich meine Gewinne?", a: "Die Gewinne werden wochenweise auf dein persönliches Dashboard gebucht und können ausbezahlt oder reinvestiert werden." },
      ],
    },
    contact: {
      tag: "Kontakt",
      h2a: "Bereit für den ",
      h2b: "nächsten Schritt?",
      sub: "Hinterlasse deine Daten und unser Team meldet sich kurzfristig — unverbindlich und individuell.",
      respTitle: "Antwortzeit",
      respVal: "In der Regel innerhalb 24 h",
      privTitle: "Vertraulich",
      privVal: "Deine Daten werden nicht weitergegeben",
      name: "Name",
      email: "E-Mail",
      phone: "Telefon",
      invest: "Geplante Investmentgröße",
      message: "Nachricht",
      heardFrom: "Wie hast du uns gefunden?",
      heardFromPlaceholder: "Bitte wählen",
      heardFromOptions: [
        { value: "google", label: "Google" },
        { value: "referral", label: "Empfehlung" },
        { value: "social_media", label: "Social Media" },
        { value: "youtube", label: "YouTube" },
        { value: "other", label: "Sonstiges" },
      ],
      referrer: "Durch wen wurdest du auf uns aufmerksam?",
      referrerPlaceholder: "Name eingeben…",
      placeholderName: "Max Muster",
      placeholderEmail: "max@example.com",
      placeholderPhone: "+41 79 950 16 46",
      placeholderInvest: "Bitte wählen",
      placeholderMessage: "Erzähl uns kurz, woran du interessiert bist…",
      submit: "Anfrage absenden",
      sending: "Senden...",
      resend: "Erneut senden",
      agbAcceptPre: "Ich habe die ",
      agbAcceptLink: "Allgemeinen Geschäftsbedingungen",
      agbAcceptPost: " gelesen und akzeptiere diese.",
      consentContact: "Ich bin damit einverstanden, dass Alphalane Trading Systems mich kontaktiert.",
      consent: "Mit dem Absenden stimmst du der Verarbeitung deiner Daten zur Bearbeitung deiner Anfrage zu.",
      phoneInvalid: "Bitte gültige Telefonnummer mit Ländervorwahl angeben (z.B. +41 79 …).",
      successToast: "Anfrage erfolgreich versendet!",
      errorToast: "Anfrage konnte nicht gesendet werden. Bitte später erneut versuchen.",
      missingFields: "Bitte fülle alle Pflichtfelder aus.",
      mustAccept: "Bitte AGB & Einwilligung akzeptieren.",
      sizes: ["2.000 – 5.000 USD", "5.000 – 25.000 USD", "25.000 – 100.000 USD", "100.000+ USD"],
      required: "*",
    },
    footer: {
      navTitle: "Navigation",
      contactTitle: "Kontakt",
      contactText: "Du hast eine Frage oder möchtest mehr erfahren? Nutze unser Kontaktformular — wir melden uns in der Regel innerhalb von 24 Stunden bei dir.",
      contactCta: "Zum Kontaktformular",
      desc: "Vollautomatisiertes KI-Trading mit Fokus auf Risikomanagement, Transparenz und Disziplin — damit du vom Markt profitierst, ohne selbst täglich zu handeln.",
      risk: "Risikohinweis: Der Handel mit Finanzinstrumenten ist mit erheblichen Risiken verbunden und kann zum Verlust des eingesetzten Kapitals führen. Vergangene Wertentwicklungen sind kein verlässlicher Indikator für zukünftige Ergebnisse. Diese Information stellt keine Anlageberatung dar.",
      copyright: "Alle Rechte vorbehalten.",
      links: { impressum: "Impressum", datenschutz: "Datenschutz", agb: "AGB" },
    },
    cookie: {
      title: "Wir verwenden Cookies",
      text: "Diese Website nutzt nur technisch notwendige Cookies. Es werden keine Tracking- oder Analyse-Tools eingesetzt. Mit „Verstanden\" bestätigst du diesen Hinweis.",
      accept: "Verstanden",
      decline: "Nur notwendige",
      privacy: "Datenschutz",
    },
    blog: {
      tag: "Blog",
      home: "Home",
      about: "Über uns",
      back: "Blog",
      h1a: "Wissen für moderne ",
      h1b: "Anleger.",
      sub: "Praxiswissen zu KI-Trading, automatisiertem Trading, passivem Einkommen und Risikomanagement — verständlich erklärt, ohne Bullshit.",
      loading: "Lade Artikel…",
      empty: "Noch keine Artikel.",
      readMore: "Weiterlesen",
      ctaEyebrow: "Bereit für den nächsten Schritt?",
      ctaTitle: "Lass dein Kapital für dich arbeiten.",
      ctaBody: "Stell uns unverbindlich eine Anfrage — wir zeigen dir, wie unser KI-Trading-System für dich arbeitet.",
      ctaButton: "Anfrage stellen",
    },
  },
  en: {
    nav: {
      konzept: "Alpha AI",
      ablauf: "How it works",
      track: "Track Record",
      konditionen: "Terms",
      faq: "FAQ",
      cta: "Get in touch",
    },
    hero: {
      tag: "Alphalane AI · AI-driven trading 24/5",
      h1a: "Alphalane AI — Profit from the markets ",
      h1b: "without trading yourself.",
      sub: "Alphalane AI (Alphalane Trading Systems) manages your trading account fully automatically based on clear, rule-based criteria. Your money stays 100% in your own name — the AI trades, you grow. Operated by Moonshine Solutions GmbH in Switzerland.",
      ctaPrimary: "Send a request",
      ctaSecondary: "How it works",
      stat1: "Active in market",
      stat2: "Performance fee",
      stat3: "Min. deposit",
      liveStatus: "Live status",
      strategy: "Strategy",
      strategyVal: "Alpha AI V2",
      drawdown: "Max interim loss",
      drawdownVal: "5% / week",
      cumulSinceTpl: "Cumulative since {month}",
      historicalNote: "Historical performance — no guarantee for future results.",
    },
    concept: {
      tag: "The concept",
      h2a: "AI technology meets ",
      h2b: "proven strategies.",
      sub: "Alphalane combines modern artificial intelligence with proven trading strategies into a system that analyzes markets, makes decisions and executes trades automatically — without stress, without emotions, around the clock.",
      cards: [
        { title: "AI analysis", text: "Real-time detection of trends & opportunities — data-driven and without delay." },
        { title: "Risk management", text: "Lock in profits, limit losses. Clear drawdown limits and manual oversight." },
        { title: "Automated", text: "Analysis, decision & execution in one closed, rule-based system." },
        { title: "Emotion-free", text: "Consistent execution — no fear, no greed, regardless of market sentiment." },
      ],
    },
    how: {
      tag: "Get started",
      h2a: "5 steps to ",
      h2b: "automated trading.",
      sub: "Clear, transparent and traceable at any time — from initial setup to real-time performance tracking.",
      steps: [
        { n: "01", title: "Define investment size", text: "Decide how much capital you want to invest. Important: Only invest capital whose loss would be acceptable to you in the worst case." },
        { n: "02", title: "Open broker account", text: "You open your own trading account with one of our partner brokers and deposit the desired amount. Account stays in your name." },
        { n: "03", title: "Connect account", text: "After completing all required steps, we link your broker account to our trading system." },
        { n: "04", title: "Trading starts", text: "Our system analyzes charts in the futures markets, finds optimal entries and executes trades according to our risk management." },
        { n: "05", title: "Stay in control", text: "Track your capital evolution in real-time via your broker account and your personal dashboard." },
      ],
    },
    track: {
      tag: "Track Record",
      h2a: "Results & ",
      h2b: "key figures.",
      sub: "Historical monthly returns since May 2025. This data is for informational purposes only — it is not a promise of future results.",
      kpiBest: "Best month",
      kpiWorst: "Worst month",
      kpiDrawdown: "Max interim loss",
      kpiCumul: "Cumulative",
      colMonth: "Month",
      colMonthly: "Return (month)",
      colCumul: "Cumulative",
      colTrend: "Trend",
      paused: "Paused for system upgrade",
      colExample: "At 10,000 start",
      exampleNote: "Example: starting capital 10,000 — ending balance based on historical performance. Past performance is not a guarantee of future results.",
      chartTitle: "Performance curve",
      chartSub: "Cumulative return since start.",
      noteTitle: "Continuous self-optimization",
      noteText: "Our AI keeps improving itself to further optimize risk management and infrastructure — for greater stability, broader diversification and shorter trade durations. The current programming has been live since March 18, 2026. All earlier monthly values are based on backtests of this current version with an accuracy of 98% (latency-related).",
      goalTitle: "Targeted monthly return 5 – 20 %",
      goalText: "Our focus is on keeping the interim loss per trade extremely low. The resulting return can never be guaranteed — but the Alphalane team strives to achieve a monthly return between 5 – 20 %. The team is always available for further information or statistics.",
      goalCta: "Request statistics",
      noteEyebrow: "Upgrade note",
      goalEyebrow: "Target",
      showAll: "Show all",
      showLess: "Show only the last 3 months",
    },
    cond: {
      tag: "Terms",
      h2a: "Clear terms. ",
      h2b: "No surprises.",
      sub: "Performance-based model: Alphalane only earns when you earn. No fixed costs, no fees in losing months.",
      benefitsTitle: "What you get",
      benefits: [
        "Fully automated trading on your own account",
        "Manual oversight by our team in addition to the strategy",
        "Audited & secured risk management",
        "Diversified trading across multiple futures markets",
        "Pausable any time, cancellable on a one-week notice",
      ],
      items: [
        { label: "Min. deposit", value: "from 2,000 USD" },
        { label: "Performance fee", value: "40% on profits" },
        { label: "Term", value: "Individual, no commitment" },
        { label: "Withdrawals", value: "within one week" },
        { label: "Account holder", value: "Solely in your name" },
        { label: "Transparency", value: "Own dashboard, real-time view" },
      ],
    },
    forwhom: {
      tag: "Who is this for",
      h2a: "For everyone who wants to ",
      h2b: "invest smart.",
      h2c: "",
      personas: [
        { title: "Investors", text: "Who want to profit from the markets without trading themselves." },
        { title: "Traders", text: "Looking for a reliable, emotion-free system." },
        { title: "Pros", text: "Who value speed, data quality and structure." },
      ],
    },
    faq: {
      tag: "FAQ",
      h2a: "Frequently asked ",
      h2b: "questions.",
      items: [
        { q: "Is my money safe?", a: "Yes. The trading account is exclusively in your name with a regulated broker. We have no access to deposits or withdrawals — only to trade execution." },
        { q: "Is there a minimum term?", a: "No, the term is individual. You can pause the service at any time or end it on one week's notice." },
        { q: "What costs do I incur?", a: "Only a performance fee of 40% on realized profits. No fixed costs, no fees in losing months." },
        { q: "What returns can I expect?", a: "There are no guaranteed returns. Actual performance depends on market conditions. Our historical results, however, show consistent development with manageable drawdowns." },
        { q: "When do I receive my profits?", a: "Profits are credited to your personal dashboard on a weekly basis and can be withdrawn or reinvested." },
      ],
    },
    contact: {
      tag: "Contact",
      h2a: "Ready for the ",
      h2b: "next step?",
      sub: "Leave your details and our team will get back to you shortly — non-binding and tailored to you.",
      respTitle: "Response time",
      respVal: "Usually within 24 h",
      privTitle: "Confidential",
      privVal: "Your data will never be shared",
      name: "Name",
      email: "Email",
      phone: "Phone",
      invest: "Planned investment size",
      message: "Message",
      heardFrom: "How did you find us?",
      heardFromPlaceholder: "Please select",
      heardFromOptions: [
        { value: "google", label: "Google" },
        { value: "referral", label: "Referral" },
        { value: "social_media", label: "Social Media" },
        { value: "youtube", label: "YouTube" },
        { value: "other", label: "Other" },
      ],
      referrer: "Who referred you?",
      referrerPlaceholder: "Enter name…",
      placeholderName: "John Doe",
      placeholderEmail: "john@example.com",
      placeholderPhone: "+41 79 950 16 46",
      placeholderInvest: "Please select",
      placeholderMessage: "Tell us briefly what you're interested in…",
      submit: "Send request",
      sending: "Sending...",
      resend: "Send again",
      agbAcceptPre: "I have read and accept the ",
      agbAcceptLink: "Terms & Conditions",
      agbAcceptPost: ".",
      consentContact: "I agree that Alphalane Trading Systems may contact me.",
      consent: "By submitting, you agree to the processing of your data for the purpose of handling your request.",
      phoneInvalid: "Please enter a valid phone number with country code (e.g. +41 79 …).",
      successToast: "Request successfully sent!",
      errorToast: "Could not send request. Please try again later.",
      missingFields: "Please fill in all required fields.",
      mustAccept: "Please accept Terms & consent first.",
      sizes: ["2,000 – 5,000 USD", "5,000 – 25,000 USD", "25,000 – 100,000 USD", "100,000+ USD"],
      required: "*",
    },
    footer: {
      navTitle: "Navigation",
      contactTitle: "Contact",
      contactText: "Have a question or want to learn more? Use our contact form — we usually respond within 24 hours.",
      contactCta: "Go to contact form",
      desc: "Fully automated AI trading with a focus on risk management, transparency and discipline — so you can profit from the markets without trading every day yourself.",
      risk: "Risk warning: Trading financial instruments carries substantial risk and may lead to the loss of invested capital. Past performance is not a reliable indicator of future results. This information does not constitute investment advice.",
      copyright: "All rights reserved.",
      links: { impressum: "Imprint", datenschutz: "Privacy", agb: "Terms" },
    },
    cookie: {
      title: "We use cookies",
      text: "This website only uses technically necessary cookies. No tracking or analytics tools are used. By clicking \"Got it\" you confirm this notice.",
      accept: "Got it",
      decline: "Necessary only",
      privacy: "Privacy",
    },
    blog: {
      tag: "Blog",
      home: "Home",
      about: "About",
      back: "Blog",
      h1a: "Insights for modern ",
      h1b: "investors.",
      sub: "Practical knowledge on AI trading, automated trading, passive income and risk management — clear and to the point.",
      loading: "Loading articles…",
      empty: "No articles yet.",
      readMore: "Read more",
      ctaEyebrow: "Ready for the next step?",
      ctaTitle: "Let your capital work for you.",
      ctaBody: "Send us a non-binding request — we'll show you how our AI trading system works for you.",
      ctaButton: "Send a request",
    },
  },
};
